import { defineEvent } from '#src/analytics/analytics_event.ts';
import { z } from 'zod';

// Event names keep their original `secret_santa:` prefix so historical analytics stay comparable.

export const GroupCreateEvent = defineEvent(
  'secret_santa:group_create',
  z.object({
    isSuccess: z.boolean(),
    hasCustomName: z.boolean(),
    participantCount: z.number().int().nonnegative(),
    exclusionCount: z.number().int().nonnegative(),
  }),
  {
    isSuccess: 'is_success',
    hasCustomName: 'has_custom_name',
    participantCount: 'participant_count',
    exclusionCount: 'exclusion_count',
  },
);

export const GroupLinkCopyEvent = defineEvent('secret_santa:link_copy', z.object({}));

export const GroupLinkViewEvent = defineEvent('secret_santa:link_view', z.object({}));

export const GroupNameConfirmEvent = defineEvent(
  'secret_santa:name_confirm',
  z.object({
    wasChosenBefore: z.boolean(),
  }),
  {
    wasChosenBefore: 'was_chosen_before',
  },
);

export const GroupNameWaitViewEvent = defineEvent(
  'secret_santa:name_wait_view',
  z.object({
    revealedCount: z.number().int().nonnegative(),
  }),
  {
    revealedCount: 'revealed_count',
  },
);

export const GroupNameDrawClickEvent = defineEvent('secret_santa:name_draw_click', z.object({}));

export const GroupNameDrawEvent = defineEvent(
  'secret_santa:name_draw',
  z.object({
    isSuccess: z.boolean(),
    failureReason: z.string().nullable(),
  }),
  {
    isSuccess: 'is_success',
    failureReason: 'failure_reason',
  },
);

export const GroupNameResetClickEvent = defineEvent('secret_santa:name_reset_click', z.object({}));

export const GroupNameResetEvent = defineEvent('secret_santa:name_reset', z.object({}));
